<template>
  <div class="bg">
    <div class="auth-wrapper auth-v1 px-2">
      <div class="auth-inner py-2">
        <b-card class="mb-0">
          <h4 class="mb-1 text-white">
            ตั้งค่า 2FA ก่อนเข้าใช้งาน
          </h4>
          <p class="text-muted mb-2">
            ระบบบังคับเปิดใช้งาน Two-Factor Authentication ก่อนเข้าสู่ระบบ
          </p>

          <b-button
            variant="outline-secondary"
            size="sm"
            class="mb-2"
            @click="backToLogin"
          >
            กลับไปหน้า Login
          </b-button>

          <account-setting-two-factor
            mandatory
            :setup-token="setupToken"
            :account-type="accountType"
            @completed="completeLogin"
          />
        </b-card>
      </div>
    </div>
  </div>
</template>

<script>
import { BCard, BButton } from 'bootstrap-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import useJwt from '@/auth/jwt/useJwt'
import { getHomeRouteForLoggedInUser, clearTwoFaSetupSession, needsAdminTwoFactor, isUserLoggedIn, storeTwoFaSetupSession, getTwoFaSetupSession } from '@/auth/utils'
import AccountSettingTwoFactor from '@/views/pages/account-setting/AccountSettingTwoFactor.vue'

export default {
  components: {
    BCard,
    BButton,
    AccountSettingTwoFactor,
  },
  data() {
    const session = getTwoFaSetupSession()
    return {
      setupToken: session ? session.token : '',
      accountType: session ? session.accountType : '',
    }
  },
  created() {
    if (isUserLoggedIn()) {
      clearTwoFaSetupSession()
      this.$router.replace({ name: 'manage-lotto-status' })
      return
    }
    if (!this.setupToken || !this.accountType) {
      this.$router.replace({ name: 'auth-login' })
    }
  },
  methods: {
    backToLogin() {
      clearTwoFaSetupSession()
      this.$router.replace({ name: 'auth-login' })
    },
    completeLogin(userData) {
      if (!userData || !userData.token) return

      clearTwoFaSetupSession()

      useJwt.setToken(userData.token)
      useJwt.setRefreshToken(userData.refreshToken)
      if (needsAdminTwoFactor(userData)) {
        userData.twoFactorEnabled = true
        sessionStorage.setItem('adminTwoFaOk', '1')
      }
      localStorage.setItem('userData', JSON.stringify(userData))
      if (userData.UserToken) {
        localStorage.setItem('UserToken', userData.UserToken)
      }
      this.$ability.update(userData.ability)

      this.$router
        .push(getHomeRouteForLoggedInUser(userData.role, userData.path))
        .then(() => {
          this.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: 'สำเร็จ',
              icon: 'ShieldIcon',
              variant: 'success',
              text: 'เปิดใช้งาน 2FA และเข้าสู่ระบบแล้ว',
            },
          })
        })
    },
  },
}
</script>

<style scoped>
.bg {
  background: #212534;
  min-height: 100vh;
}
.card {
  border-radius: 14px !important;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1) !important;
  background-color: rgba(0, 0, 0, 0.774) !important;
}
</style>
